import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_button_set extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_button_set">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Button Set</h2>
              <p>
                Record button set is an extension of record button and allows
                you to to display multiple buttons horizontally on the page.
                Record button sets can be aligned to the left or the right hand
                side of the container. The "buttons" property is a container of
                "record_button" for more information look up record button.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_button_set"}
                name={"button set"}
                dataNameDefault={
                  '"date_click_button" or "object_my_obj.date_click_button"'
                }
                padding={true}
                hide={true}
                order={true}
                button={false}
                tabIndex={false}
                displayName={false}
                properties={[
                  {
                    property: "button_position",
                    description: "Button set alignment.",
                    defaults: '"left", "right", default is "right"',
                  },
                  {
                    property: "buttons",
                    description: "Record button container.",
                    defaults: "{ ... }",
                  },
                ]}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Button Set Example</h2>
            </section>
            <section>
              <h3>Example 1: Three Buttons</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_button_set"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"button_position"</span>:{" "}
                  <span className="jsonY">"right"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"buttons"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"my_frist_button"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My First Button"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"button_color"</span>:{" "}
                  <span className="jsonY">"#01579B"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"button_font_color"</span>:{" "}
                  <span className="jsonY">"#FFFFFF"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"button_width"</span>:{" "}
                  <span className="jsonP">120</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"on_click_eval"</span>:{" "}
                  <span className="jsonY">
                    "console.log('Button was clicked.')"
                  </span>
                  ,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div className="i2">&#125;,</div>

                <div className="i2">
                  <span className="jsonG">"my_second_button"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My Second Button"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"button_color"</span>:{" "}
                  <span className="jsonY">"#01579B"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"button_font_color"</span>:{" "}
                  <span className="jsonY">"#FFFFFF"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"button_width"</span>:{" "}
                  <span className="jsonP">120</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"on_click_eval"</span>:{" "}
                  <span className="jsonY">
                    "console.log('Button was clicked.')"
                  </span>
                  ,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">
                  <span className="jsonG">"my_third_button"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My Third Button"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"button_color"</span>:{" "}
                  <span className="jsonY">"#01579B"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"button_font_color"</span>:{" "}
                  <span className="jsonY">"#FFFFFF"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"button_width"</span>:{" "}
                  <span className="jsonP">120</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"on_click_eval"</span>:{" "}
                  <span className="jsonY">
                    "console.log('Button was clicked.')"
                  </span>
                  ,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">3</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>

                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_button_set;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_button_set.js